module.exports = __webpack_public_path__ + "static/media/3.e00fb46b.jpg";